// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Appointment, Encounter } from '@medplum/fhirtypes';

const APPOINTMENT_TYPE_SYSTEM = 'http://polarissleep.com/appointment-types';
const INTAKE_APPOINTMENT_CODE = 'new-patient-intake';

function hasIntakeCoding(codings: { system?: string; code?: string }[] | undefined): boolean {
  return Boolean(
    codings?.some((coding) => coding.system === APPOINTMENT_TYPE_SYSTEM && coding.code === INTAKE_APPOINTMENT_CODE)
  );
}

export function isIntakeEncounter(encounter?: Encounter, appointment?: Appointment): boolean {
  const encounterCodings = encounter?.type?.flatMap((type) => type.coding ?? []);
  if (encounterCodings?.length) {
    return hasIntakeCoding(encounterCodings);
  }

  return hasIntakeCoding(appointment?.appointmentType?.coding);
}
